import {IncomingPropertyDataTypes, InternalPropertyDataTypes, LocationType, OrderTypes} from './enums'

export function capitalize (str) {
  return str ? (str[0].toUpperCase() + str.slice(1)) : ''
}

export function uid () {
  return ('' + window.performance.now() + Math.random()).replace(new RegExp('\\.', 'g'), '-')
}

export function compareTrees (aTree, bTree) {
  let a = aTree.control.name
  let b = bTree.control.name

  if (a > b) return 1
  if (a < b) return -1
  return 0
}

export function classNames () {
  let classes = []

  for (let i = 0; i < arguments.length; i++) {
    const arg = arguments[i]
    if (!arg) continue

    const argType = typeof arg

    if (argType === 'string' || argType === 'number') {
      classes.push(arg)
    } else if (Array.isArray(arg) && arg.length) {
      const inner = classNames.apply(null, arg)
      if (inner) {
        classes.push(inner)
      }
    } else if (argType === 'object') {
      for (let key in arg) {
        if (arg.hasOwnProperty(key) && arg[key]) {
          classes.push(key)
        }
      }
    }
  }

  return classes.join(' ')
}

export function compareLocations (a, b) {
  let aKeyIndex = Object.values(LocationType).indexOf(a.type)
  let bKeyIndex = Object.values(LocationType).indexOf(b.type)

  if (aKeyIndex < bKeyIndex) return 1
  else if (aKeyIndex > bKeyIndex) return -1
  else if (a.location.name > b.location.name) return 1
  else if (a.location.name < b.location.name) return -1
  else return 0
}

export function controlsTreeToMap (tree, map = {}) {
  if (tree.children.length > 0) {
    tree.children.forEach(child => {
      map = controlsTreeToMap(child, map)
    })
    if (tree.children.some(child => child.value === null)) {
      map[tree.control.uuid] = tree.value
    }
  } else {
    map[tree.control.uuid] = tree.value
  }
  return map
}

function setChildrenToNull (tree) {
  tree.children.forEach(child => {
    child.value = null
    setChildrenToNull(child)
  })
}

export function setTreeToNulls (tree) {
  tree.value = null
  setChildrenToNull(tree)
}

export function setControlRecursive (controls, uuid, value) {
  if (controls.length > 0) {
    return controls.some(tree => {
      if (tree.control.uuid === uuid) {
        tree.value = parseFloat(value)
        setChildrenToNull(tree)
        return true
      }
      if (tree.children.length > 0) {
        return setControlRecursive(tree.children, uuid, value)
      }
    })
  }
}

export function cloneObject (obj) {
  let clone

  if (obj != null && Array.isArray(obj)) {
    clone = []
    for (let k in obj) {
      clone[k] = cloneObject(obj[k])
    }
  } else if (obj != null && typeof (obj) === 'object') {
    clone = {}
    for (let i in obj) {
      if (obj[i] != null && Array.isArray(obj[i])) {
        clone[i] = []
        for (let k in obj[i]) {
          clone[i][k] = cloneObject(obj[i][k])
        }
      } else if (obj[i] != null && typeof (obj[i]) === 'object') {
        clone[i] = cloneObject(obj[i])
      } else {
        clone[i] = obj[i]
      }
    }
  } else {
    clone = obj
  }

  return clone
}

// TODO: Check this
export function assert (condition, message) {
  if (!condition) {
    throw new Error(message || 'Assertion error!')
  }
}

export function assertString (str) {
  if (!str || typeof str !== 'string') {
    throw new Error('Assertion error!')
  }
}

export function comp (key) {
  if (typeof key === 'string') {
    let fields = key.split('.')

    const getNextKey = (obj, keysArray) => {
      if (keysArray.length === 0) {
        return obj
      } else {
        try {
          return getNextKey(obj[keysArray[0]], keysArray.slice(1))
        } catch (e) {
          return null
        }
      }
    }

    const getKey = obj => {
      return getNextKey(obj, fields)
    }

    return function (a, b) {
      if (getKey(a) < getKey(b)) return -1
      if (getKey(a) > getKey(b)) return 1

      return 0
    }
  } else if (typeof key === 'function') {
    return function (a, b) {
      if (key(a) < key(b)) return -1
      if (key(a) > key(b)) return 1

      return 0
    }
  } else {
    throw new Error('Wrong argument!')
  }
}

export function tableValues (data, fields = false) {
  data = Object.assign({}, data)
  if (fields === false) {
    data.id = null
    data.uuid = null
  } else if (Array.isArray(fields)) {
    Object.keys(data).forEach(key => {
      if (!fields.includes(key)) {
        data[key] = null
      }
    })
  }

  return Object.keys(data)
    .filter(key => data[key] != null && typeof data[key] !== 'object')
    .reduce((obj, key) => {
      obj[key] = data[key]
      return obj
    }, {})
}

export function getEntityName (entity) {
  const na = '--- n/a ---'
  if (!entity) {
    return na
  }
  if (typeof entity === 'object') {
    return entity.name ||
      entity.created ||
      na
  } else {
    return entity
  }
}

export function errorCatch (title, vm) {
  return error => {
    vm.$notify.error({
      title: title,
      message: (error.response && error.response.data) || error.message,
      position: 'top right',
      timeOut: 60000,
      closeButton: true
    })
    throw error
  }
}

export const determineLocationTypeIcon = (locationType) => {
  switch (locationType) {
    case LocationType.TERMINAL:
      return 'warehouse'
    case LocationType.AIRPORT:
      return 'plane'
    case LocationType.SEAPORT:
      return 'ship'
    case LocationType.RAILWAY_STATION:
      return 'train'
    case LocationType.PICKUP_DELIVERY_ZONE:
      return 'dot-circle'
    case LocationType.CITY:
      return 'city'
    case LocationType.COUNTRY:
      return 'flag'
    case LocationType.REGION:
      return 'globe'
  }
}

export const equalArrays = (arr1, arr2) => {
  const equalLength = arr1.length === arr2.length
  const equalElements = arr1.every((v, i) => {
    return arr1[i] === arr2[i]
  })
  return equalLength && equalElements
}

export const transformDataType = type => {
  if (Object.values(InternalPropertyDataTypes).includes(type)) {
    return type
  }
  switch (type) {
    case IncomingPropertyDataTypes.FLOAT:
      return InternalPropertyDataTypes.NUMBER
    case IncomingPropertyDataTypes.INTEGER:
      return InternalPropertyDataTypes.NUMBER
    case IncomingPropertyDataTypes.STRING_ARRAY:
      return InternalPropertyDataTypes.STRING_ARRAY
    case IncomingPropertyDataTypes.LONG_ARRAY:
      return InternalPropertyDataTypes.NUMBER_ARRAY
    default:
      throw new Error(`Unknown incoming data type: "${type}"!`)
  }
}

export const formatDT = dtObj => {
  return dtObj
    ? [
      `${('0' + dtObj.hour).slice(-2)}:${('0' + dtObj.minute).slice(-2)}:${('0' + dtObj.second).slice(-2)}`,
      ' ',
      `${('0' + dtObj.dayOfMonth).slice(-2)}.${('0' + dtObj.monthValue).slice(-2)}.${('000' + dtObj.year).slice(-4)}`
    ].join('') : null
}

export const formatDT2 = dtObj => {
  return dtObj
    ? [
      `${('000' + dtObj.year).slice(-4)}-${('0' + dtObj.monthValue).slice(-2)}-${('0' + dtObj.dayOfMonth).slice(-2)}`,
      'T',
      `${('0' + dtObj.hour).slice(-2)}:${('0' + dtObj.minute).slice(-2)}:${('0' + dtObj.second).slice(-2)}`
    ].join('') : null
}

export const formatD = dtObj => dtObj ? `${('0' + dtObj.dayOfMonth).slice(-2)}.${('0' + dtObj.monthValue).slice(-2)}.${('000' + dtObj.year).slice(-4)}` : null
export const formatT = dtObj => dtObj ? `${('0' + dtObj.hour).slice(-2)}:${('0' + dtObj.minute).slice(-2)}` : null

export const calculateTotalWithOptional = (row, {selectedOptionalTypes, currency}) => {
  const optionalSum = row.rateData.rate.optional
    .filter(opt => selectedOptionalTypes.includes(opt.rate.type))
    .map(opt => {
      if (currency) {
        const amount = opt.price.amounts.find(amount => amount.currency === currency)
        return amount ? amount.amount : 0.0
      } else {
        return opt.price.amount || 0.0
      }
    }).reduce((sum, x) => sum + x, 0.0)

  if (currency) {
    const amount = row.total.amounts.find(amount => amount.currency === currency)
    return optionalSum + (amount ? amount.amount : 0.0)
  } else {
    return optionalSum + row.total.baseAmount
  }
}

export const cargoInfo = cargo => {
  const measureUnits = cargo.data
  return measureUnits.map((mu) => {
    return `${mu.name}: ${mu.value.toFixed(2)}`
  }).join('; ')
}

export const orderType = order => {
  return (order && order.agent) ? OrderTypes.AGENT : ((order && order.client) ? OrderTypes.CLIENT : null)
}



// WEBPACK FOOTER //
// ./src/utils.js